const n = {
  name: "ChevronsDown",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0002 15.5859L8.00015 11.5859L6.58594 13.0002L12.0002 18.4144L17.4144 13.0002L16.0002 11.5859L12.0002 15.5859Z" fill="currentColor"/>
<path d="M12.0002 9.58594L8.00015 5.58594L6.58594 7.00015L12.0002 12.4144L17.4144 7.00015L16.0002 5.58594L12.0002 9.58594Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as ChevronsDown
};
